import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { CaseTreeNode } from '../../state/cases/cases.state'
import { environment } from '../../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class DatasetBrowserApiService {
    private readonly baseUrl = environment.apiUrl

    constructor(private readonly http: HttpClient) {}

    getFolders(): Observable<CaseTreeNode[]> {
        return this.http
            .get<{ children: CaseTreeNode[] }>(`${this.baseUrl}/datasets`)
            .pipe(map(cases => cases.children))
    }

    createFolder(name: string, parentId: number | null): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/folders`, { name, parentId })
    }

    moveFolder(folderId: number, targetId: number | null): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/folders/${folderId}?parent=${targetId}`, {})
    }

    deleteFolder(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/folders/${id}`)
    }

    createDataset(name: string): Observable<number> {
        return this.http.post<number>(`${this.baseUrl}/datasets/`, { name })
    }

    moveDataset(datasetId: number, targetId: number | null): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/datasets/${datasetId}?parent=${targetId}`, {})
    }

    deleteDataset(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/datasets/${id}`)
    }
}
